export class Satzart {
    static readonly Plan = 10;
    static readonly Impfung = 20;
    static readonly Text = 30;
    static readonly Leistung = 40;
    static readonly Untersuchung = 50;
    static readonly Diagnose = 60;
    static readonly Anamnese = 70;
    static readonly Brief = 80;
    static readonly Rezept = 90;

    static values(): number[] {
        return Object.values(this);
    }
}
